import { useState, useRef, useEffect } from 'react'

export function useScrollPosition(dependencies = []) {
  const [isScrollable, setIsScrollable] = useState(false)
  const [isAtBottom, setIsAtBottom] = useState(false)
  const scrollRef = useRef(null)

  useEffect(() => {
    const scrollElement = scrollRef.current
    if (!scrollElement) {
      return
    }

    // Check if content is scrollable
    const checkScrollability = () => {
      setIsScrollable(scrollElement.scrollHeight > scrollElement.clientHeight)
    }

    // Check scroll position
    const checkScrollPosition = () => {
      setIsAtBottom(
        scrollElement.scrollTop + scrollElement.clientHeight >= scrollElement.scrollHeight - 1
      )
    }

    // Initial checks
    checkScrollability()
    checkScrollPosition()

    // Add event listeners
    scrollElement.addEventListener('scroll', checkScrollPosition)
    window.addEventListener('resize', checkScrollability)

    // Cleanup event listeners
    return () => {
      scrollElement.removeEventListener('scroll', checkScrollPosition)
      window.removeEventListener('resize', checkScrollability)
    }
  }, [dependencies])

  return {
    scrollRef,
    isScrollable,
    isAtBottom,
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/hooks/useScrollPosition/index.js